module.exports = __webpack_public_path__ + "static/media/autochilango-minus.8b88ef6b.svg";